// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE (Supabase migration V2 - PREVIEW ONLY)
// version  : 1.0
// updated  : 2026-06-19
// protected: NO
// =============================================================================
// Halaman Monitoring V2 (membungkus komponen V2Monitoring dengan auth context).
import React from "react";
import { useV2Auth } from "@/v2/V2AuthContext";
import { V2Monitoring } from "@/components/V2Monitoring";

export default function MonitoringPage() {
  const { me, authHeader } = useV2Auth();
  return <V2Monitoring authHeader={authHeader} role={me?.role} />;
}
